// * React and Redux:
import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../features/LoadingSlice';

// * Material UI components:
import { 
    Checkbox, 
    Chip, 
    Divider,
    Avatar,
    Stack,
    Tooltip,
    Typography,
    IconButton,
    ListItem,
    ListItemText,
    ListItemAvatar,
    CircularProgress
} from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

// * Own components:
import { StyledProgress } from "./styled_components/StyledProgress";

// * Handlers:
import handleDeleteOwnArea from '../handlers/handleDeleteOwnArea';
import handleModifyGroupOfAreas from '../handlers/handleModifyGroupOfAreas';

// * Other:
import { v4 as uuidv4 } from 'uuid';

const Subarea = ({ 
    name, 
    adminLevel, 
    areaId, 
    onClick, 
    onDeleteClick, 
    onCheckboxClick, 
    isFirst, 
    state, 
    powerKW, 
    setPowerKW,
    percentage, 
    areaArray, 
    setAreaArray 
}) => {

    const {id, code} = useParams();
    const dispatch = useDispatch();
    const loading = useSelector((state) => state.loading.isLoading);
    const texts = useSelector((state) => state.texts.texts);
    const uniqueId = `subarea-${uuidv4()}`;
    const [checkboxState, setCheckboxState] = useState(state);
    const [lock, setLock] = useState(false); // Wyłączenie możliwości kliknięcia na czas operacji asynchronicznej. 

    useEffect(() => {
        setCheckboxState(state);
    }, [state]);

    return (
        <div onClick={onClick} id={uniqueId}>
            {
                isFirst ? <></> : <Divider light={true}/>
            }
            <ListItem>
                {
                    percentage !== null ?
                    <ListItemAvatar>
                        <Avatar style={{background: "inherit", border: "1px solid grey", color: "grey"}}>
                            <StyledProgress value={(percentage * 100).toFixed(2)} mode="subarea"/>
                        </Avatar>
                    </ListItemAvatar> : <></>
                }
                <ListItemText style={{fontWeight: "bold"}}>
                    <Stack>
                        <Typography variant="h7" style={{marginBottom: "0.5em"}}>
                            {name}
                        </Typography>
                        <Tooltip
                            title={texts['tooltip_admin_level']}
                            arrow
                        >
                        {
                            adminLevel !== 0 ? 
                            <Chip
                                avatar={ 
                                    adminLevel !== 0 ?
                                    <Avatar style={{background: 'transparent'}}>{adminLevel}</Avatar> : <></>
                                }
                                clickable
                                style={{width: "fit-content", border: "1px solid grey"}}
                                label={ 
                                    <Typography variant="p" style={{marginLeft: "0.25em"}}>
                                        { texts[`admin_level_${adminLevel}`] !== undefined ? texts[`admin_level_${adminLevel}`] : "" } 
                                    </Typography>
                                }
                            /> : <></>
                        }
                        </Tooltip>
                    </Stack>
                </ListItemText>
                {
                    lock ? 
                    <CircularProgress color="success" size={20} style={{marginRight: '0.5em'}}/>
                    : <></>
                }
                {
                    adminLevel === 0 ? 
                    <IconButton
                        disabled={false}
                        onClick={() => {
                            handleDeleteOwnArea({ id, code, areaId, areaArray, setAreaArray, setLock });
                        }}
                    >
                        <DeleteOutlineIcon/>
                    </IconButton> :
                    <></>
                }
                <Tooltip
                    title={
                        checkboxState === 'positive' ? texts['checkbox_checked'] :
                        checkboxState === 'negative' ? texts['checkbox_negative'] :
                        texts['checkbox_unchecked']
                    }
                >
                    <Checkbox 
                        className='right' 
                        disabled={loading || lock}
                        checked={checkboxState === 'positive'}
                        indeterminate={checkboxState === 'negative'}
                        color= {
                            checkboxState === 'positive' ? 'success' :
                            checkboxState === 'negative' ? 'error' :
                            'default'
                        }
                        onClick={(_) => {
                            setLock(true);
                            dispatch(setLoading(true));
                            const newCheckboxState = 
                                checkboxState === 'positive' ? 'neutral' :
                                checkboxState === 'negative' ? 'positive' :
                                'negative';
                            handleModifyGroupOfAreas(
                                id, 
                                code, 
                                areaId, 
                                name, 
                                newCheckboxState, 
                                setPowerKW, 
                                () => {
                                    setLock(false);    
                                    dispatch(setLoading(false));
                                }, 
                                areaArray, 
                                setAreaArray
                            );
                        }}  
                    />
                </Tooltip>
            </ListItem>
        </div>
    );
};

export default Subarea;